export function decimalToBinaryString(number, padMultiple) {
    var binaryString = (number >>> 0).toString(2);
    if (!padMultiple) {
        return binaryString;
    }
    while (binaryString.length % padMultiple !== 0) {
        binaryString = '0' + binaryString;
    }
    return binaryString;
}
//# sourceMappingURL=NumberHelpers.js.map